import { Box, Typography } from '@mui/material';
import { UserEntity } from 'app/interfaces/entity';
import React, { FC } from 'react';
import { UserAvatar } from 'shared/components/UserAvatar';
import Talk from 'talkjs';

interface PopupParticipantCardProps {
  user: Talk.UserData | null;
}

export const PopupParticipantCard: FC<PopupParticipantCardProps> = ({ user }) => {
  if (!user) {
    return (
      <Box display="flex" alignItems="center">
        <Typography fontWeight="bold" pl={1}>
          Private Message
        </Typography>
      </Box>
    );
  }

  return (
    <Box display="flex" alignItems="center">
      <UserAvatar withOnlineIndicator={false} user={user as unknown as UserEntity} />
      <Typography fontWeight="bold" pl={1}>
        {user?.name}
      </Typography>
    </Box>
  );
};
